export const docs = {
  'hhsynth': '\nhhsynth(trig:every(1/16)) |> out($)',
  'bs': '\nwhite() |> bs($,100+10k*lfosine(1),1) |> out($)',
  'write':
    'flanger=(in,seconds=0.5)->{\n  buf=alloc(1)\n  sample=read(buf,seconds)\n  write(in+sample*.95,buf)\n  sample\n}\n\ntri(ntof(60))*ad(trig:every(1/2)) |> $+flanger($*.41,.0036+0.004*lfosine(4)) |> out($)\n',
  'mix': 'drums() |> out($)\n\n\nmix=>dc($) |> limiter($)',
  'bpm': 'bpm=144\n\ndrums() |> out($)',
  'impulse': '\ntri([60,63,65,69][t]|>ntof($))*ad(trig:impulse(8)) |> out($)',
  'miditohz': 'a',
  '[].step': '\n[60,63,65].step(impulse(4)) |> ntof($) |> saw($) |> out($)',
  'bss': '\nwhite() |> bss($,100+10k*lfosine(1),.5) |> out($)',
  'freesound': '\n\nsampler(freesound(350547),trig:1) |> out($)',
  'saw': '\nsaw(ntof(31)) |> out($)',
  '[].Step': 'a',
  'scale': 'scale=\'dorian\'\n\n;(#scale*o2).walk(1/4) |> saw($) |> out($)',
  '[].map': '\n[60,63,65].map(ntof)[t] |> saw($)*ad(trig:every(1/8)) |> out($)',
  'compressor': '\ndrums() |> compressor($,.0001,.002,-20,6,2)*4.0 |> out($)',
  'lforamp': '\npink()*lforamp(1) |> out($)',
  'hp': '\nwhite() |> hp($,100+10k*lfosine(1),1) |> out($)',
  'isinf': '\nisinf(1/0) |> print($)',
  'hp1': '\nwhite() |> hp1($,100+10k*lfosine(1)) |> out($)',
  'inc': '\npink()*inc(1,trig:every(1/2)) |> out($)',
  'bd': '\nbd() |> out($)',
  'timeline':
    '\nsaw(330) |> lp($,150+2k*ad(trig:every(1/4))) \n\n* timeline(\'1,1e2 2,0e-2 3,1e-3 4,0e-2\',4) |> out($)',
  'hold': '\n[60,0,63,0,65,0][t*2] |> hold($) |> print($) |> ntof($) |> tri($) |> out($)',
  'sampler': '\n\nsampler(freesound(350547),trig:1) |> out($)',
  'dattorro': `scale='dorian'

drums() |> out($)

trig:=euclid(5,8,bar:1);[#1,#3,#5,#7,#9].random(trig)*[o1,o2,o3][t]

|> saw($)*ad(.0001,.13,trig)*.4 |> lp($,100+10k*ad(trig))


|> $+delay($,.15,.2) |> $+dattorro($) |> out($)`,
  '#scale': 'scale=\'dorian\'\n\n;(#scale*o2).walk(1/4) |> saw($) |> out($)',
  'exp2': '\nexp2(sine(ntof(30))) |> dc($) |> out($)',
  'lfosah': '\nsine(24*lfosah(1/16)|>ntof(floor(60+$))) |> out($)',
  'sine': 'melody=[60,63,69].map(ntof)\n\nsine(melody[t])*ad(trig:every(1/16))*ad(trig:every(1/16)) |> out($)',
  'safediv': '\nsafediv(1,0) |> print($)',
  'square': '\nsquare(sine(ntof(30))) |> out($)',
  'acos': '\nacos(sine(ntof(30))) |> out($)',
  'aps':
    'phaser=(in,stages=10)->{\n  a = lfosine(.5)\n\n  y = in\n  for (i in 0 .. stages-1) {\n    y = aps(y,99+999*a)\n  }\n\n  y + in\n}\n\nsaw(299)*.4 |> phaser($) |> out($)',
  'log10': '\nlog10(abs(sine(ntof(30)))+.01) |> dc($) |> out($)',
  'round': '\nround(sine(ntof(30))) |> out($)',
  'tan': '\ntan(sine(ntof(30))) |> out($)',
  'random': '\nrandom() |> print($) |> out($)',
  'lerp': '\nntof(30) |> lerp(sqr($),saw($),lfosine(1)) |> out($)',
  'outs': '\nsaw(ntof(30)) |> out($)\n\ntri(ntof(30)) |> outs($)',
  'brown': '\nbrown() |> out($)',
  'diodeladder':
    'trig=every(1/16) \n\ndiodeladder([68,99,56,85][t*2]/2 |> ntof($) |> slew($,.00003,e:.5) |> ramp($),\n\ncutoff:99+.3k*(1.00+7*fractal(rate:.015)**2)*ad(.002,4.0,10,trig),\n\nq:.99,k:.0001,sat:.86) |> tanh($*5) |> dc($) |> $*.25+drums() |> limiter($) |> out($)',
  'lfosine': '\npink()*lfosine(1) |> out($)',
  'o0': '\n(#vi7sus4*o2).map(saw).avg() |> out($)',
  '#i': '\n(#vi7sus4*o2).map(saw).avg() |> out($)',
  'isfunction': '\nisfunction(() -> {}) |> print($)\n\nisfunction(1) |> print($)',
  'hs': '\nwhite() |> hs($,100+10k*lfosine(1),1,-30) |> out($)',
  '[].walk': '\n[60,63,65].walk(1/8,.25) |> ntof($) |> saw($) |> out($)',
  '[].fit': '\n[60,63,65].fit(1) |> ntof($) |> saw($) |> out($)',
  'asin': '\nasin(sine(ntof(30))) |> out($)',
  'max': '\nntof(30) |> max(sine($),saw($)) |> out($)',
  'pink': '\npink() |> out($)',
  'hps': '\nwhite() |> hps($,100+10k*lfosine(1),.5) |> out($)',
  'pitchshift':
    '\n\nslicer(freesound(350547),slice:random(),trig:every(1/2)) \n\n|> pitchshift($,.6+.8*lfotri(2)) |> out($)',
  'smootherstep': '\nntof(30) |> smootherstep(sqr($),saw($),lfosine(1)) |> dc($) |> out($)',
  'envfollow':
    'kick=(x,trig=1)->sine(x+18000*ad(.001,.8,trig)**300,offset:.5,trig)*ad(.012,.8,trig)**16\n\nk=kick(52,trig:every(1/4)) |> out($)\n\npink() |> $*envfollow(k) |> out($)\n',
  'avg': '\n[1,2,3].avg() |> print($)',
  'hypot': '\nhypot(sine(ntof(30)),saw(ntof(43))) |> dc($) |> out($)',
  'fractal': '\nsine(100+sine(173*fractal(rate:.007))*fractal(rate:.005)*607) |> out($)',
  'record':
    'kicksynth=(x,trig=1)->sine(x+18000*ad(.001,.8,trig)**300,offset:.5,trig)*ad(.012,.8,trig)**16\n\nkick=(y=52,trig=every(1/4))->{ \n  sample=record(.2,()->kicksynth(y))\n  \n  sampler(sample,trig,offset:.05)\n}\n\nkick(52,trig:every(1/4)) |> out(       $)\n',
  'slew': '\n[60,63,65][t] |> ntof($) |> saw(slew($,.0001))*ad(trig:every(1/8)) |> out($)',
  'select': '\nntof(30) |> select(fract(t)>.5,tri($),saw($)) |> out($)',
  'lpm': '\nwhite() |> lpm($,100+10k*lfosine(1),.5) |> out($)',
  'lp': '\nwhite() |> lp($,100+10k*lfosine(1),1) |> out($)',
  'limiter': '\ndrums() |> limiter($,-15)*5.0 |> out($)',
  '#1': '\n([#1,#3,#5,#7]*o3).map(saw).avg() |> out($)',
  'pwm': '\npwm(ntof(37),width:lfosine(1)) |> out($)',
  'tram': 'trig=tram(\'x-x-x-[xxx]-\',1/2)\n\nsine(80+100*ad(.001,.92,4,trig))*ad(.00001,.12,4,trig) |> out($*.75)',
  'white': '\nwhite() |> out($)',
  'lps': '\nwhite() |> lps($,100+10k*lfosine(1),.5) |> out($)',
  'zerox': '\nsaw(ntof(51))*ad(trig:zerox(saw(1))) |> out($)',
  'isnan': '\nisnan(0/0) |> print($)',
  'isscalar': '\nisscalar(sine(1)) |> print($)\n\nisscalar(1) |> print($)',
  'mod': '\nntof(30) |> mod(sine($),saw($)) |> out($)',
  'lfosaw': '\npink()*lfosaw(1) |> out($)',
  'out': '\nsine(ntof(69)) |> out($)',
  'bp': '\nwhite() |> bp($,100+10k*lfosine(1),1) |> out($)',
  'sdsynth': '\nsdsynth(trig:tram(\'-x\',1/2)) |> out($)',
  'ceil': '\nceil(sine(ntof(30))) |> out($)',
  'sd': '\nsd() |> out($)',
  'every': '\ntri([60,63,65,69][t]|>ntof($))*ad(trig:every(1/8)) |> out($)',
  'tri': '\ntri(ntof(31)) |> out($)',
  'c4': '\n;[c4,a4,f4,e4][t] |> saw($) |> out($)',
  'ntof': '\n[60,63,65][t] |> ntof($) |> saw($)*ad(trig:every(1/8)) |> out($)',
  'heaviside': '\nheaviside(sine(ntof(30))) |> dc($) |> out($)',
  'karplus': '\nkarplus([49,58,53,64][swing(t,.85)]|>ntof($),seed:33,trig:every(1/8)) |> out($)',
  'trunc': '\ntrunc(4.2) |> print($)\n\ntrunc(-4.2) |> print($)',
  'slicer':
    'hihats=()->{\n  sample=freesound(274511)\n\n  slicer(sample,slice:1-(sine(.4*co)*.5+.5),speed:1,threshold:.008,trig:every(1/16))\n}\n\nhihats() |> out($)',
  'smooth': '\nsine(100+sine(173*smooth(rate:1.007))*smooth(rate:1.005)*607) |> out($)',
  'bdsynth': '\nbdsynth() |> out($)',
  'isarray': '\nisarray([]) |> print($)\n\nisarray(0) |> print($)',
  'emit': 'a',
  'snap': '\nsnap(lfosine(1),.2) |> ntof(48+$*12) |> saw($) |> out($)',
  'tube': '\nsaw(ntof(30)) |> tube($,3,.2) |> out($)',
  'freeverb':
    '\ndrums() |> out($)\n\ntrig=tram(\'x-x-x-[xxx]-\',1/2) \n\ntri(95+[158,100][t*8]*ad(.001,.77,trig)**2)*ad(.00001,.24,trig)**3*.4\n\n\n\n|> $+freeverb($,.55,.6)*1 |> out($)\n\n;[47,50,51][t*4]|>ntof($)*1 |> rhodes($,trig:every(1/16))*.08 |> out($)\n\n;[51,54,55][t*4]|>ntof($)*2 |> rhodes($,trig:every(1/16))*.03 |> out($)',
  'step': '\nstep(lfosine(1),sine(ntof(30))) |> dc($) |> out($)',
  'tune': 'scale=\'dorian\' tune=1.50\n\n;(#scale*o2).walk(1/4) |> saw($) |> out($)',
  'lfotri': '\npink()*lfotri(1) |> out($)',
  'ramp': '\nramp(ntof(31)) |> out($)',
  'clamp': '\nclamp(sine(ntof(30)),-.1,.1) |> out($)',
  'transpose': 'scale=\'dorian\' transpose=1\n\n;(#scale*o2).walk(1/4) |> saw($) |> out($)',
  'wrap': '\nwrap(sine(ntof(30)),-.1,.1) |> out($)',
  'chorus': '\nsaw(ntof(30)) |> chorus($) |> out($)',
  'dc': '\nrandom()+1 |> dc($) |> out($)',
  'alloc':
    'flanger=(in,seconds=0.5)->{\n  buf=alloc(1)\n  sample=read(buf,seconds)\n  write(in+sample*.95,buf)\n  sample\n}\n\ntri(ntof(60))*ad(trig:every(1/2)) |> $+flanger($*.41,.0036+0.004*lfosine(4)) |> out($)\n',
  '[].Walk': 'a',
  '[].Fit': 'a',
  'bps': '\nwhite() |> bps($,100+10k*lfosine(1),.50) |> out($)',
  'sout': '\nsaw(ntof(30)) |> out($)\n\ntri(ntof(30)) |> sout($)',
  'sah': '\nrandom() |> sah($,every(1/4)) |> ntof(60+floor($*12)) |> saw($) |> out($)',
  'sqrt': '\nsqrt(sine(ntof(30))) |> out($)',
  'peak': '\nwhite() |> peak($,100+10k*lfosine(1),1,10) |> out($)',
  'exp': '\nexp(sine(ntof(30))) |> dc($) |> out($)',
  'floor': '\nfloor(sine(ntof(30))) |> dc($) |> out($)',
  'min': '\nntof(30) |> min(sine($),saw($)) |> out($)',
  'flanger': '\nsaw(ntof(30)) |> flanger($) |> out($)',
  'rhodes': 'trig=every(1/16)\n\nrhodes([60,63,65,70][t*2]|>ntof($),.7,trig)*ad(.0001,.36,4,trig) |> out($)',
  'at': `trig=at(1/16,1/4)+at(3/16,1/4)+at(4/16,1/4)

tri([60,67,62,63][t]|>ntof($)|>$/2+sine($/3)*$/2)*ad(.0003,.11,e:.5,trig)*.3+drums() |> out($)`,
  'moddelay': '\nsaw(ntof(30)) |> moddelay($,.3,.3,.11,.20) |> out($)',
  'solo': '\nsaw(ntof(30)) |> out($)\n\ntri(ntof(30)) |> solo($)',
  'fold': '\nfold(sine(ntof(30)),-.2,.2) |> out($)',
  'isundefined': '\nisundefined(undefined) |> print($)\n\nisundefined(1) |> print($)',
  'log2': '\nlog2(abs(sine(ntof(30)))+.01) |> dc($) |> out($)',
  'adsr': `
drums() |> out($)

play(mini('o5 <octave -1 octave 0>/2
  scale pent [1;2 4 [4 2] 5];.4/2'),({hz,trig})->

  (saw(hz/3)+sqr(hz))*adsr(.001,.03,.6,.04,2,trig)*.25

  |> lps($,100+15k*ad(.001,.5,8,trig),.8)

) |> out($)`,
  'hpm': '\nwhite() |> hpm($,100+10k*lfosine(1),.5) |> out($)',
  'read':
    'flanger=(in,seconds=0.5)->{\n  buf=alloc(1)\n  sample=read(buf,seconds)\n  write(in+sample*.95,buf)\n  sample\n}\n\ntri(ntof(60))*ad(trig:every(1/2)) |> $+flanger($*.41,.0036+0.004*lfosine(4)) |> out($)\n',
  'ad': '\ntri([c4,a4,f4,e4][t])*ad(a:.03,d:.15,e:5,trig:every(1/8)) |> out($)',
  'velvet':
    '\ndrums() |> out($)\n\nsupersaw([62,63,65,68][t]|>ntof($)*[1,.5][t/4])*ad(trig:every(1/16))\n\n|> lp($,1k+8k*ad(e:5,trig:every(1/16)))*.35\n\n\n\n|> $+velvet($,room:.8) |> out($)',
  'mini': `
drums() |> out($)

play(mini('o5 <octave -1 octave 0>/2
  scale pent [1;2 4 [4 2] 5];.4/2'),({hz,trig})->

  (saw(hz/3)+sqr(hz))*adsr(.001,.03,.6,.04,2,trig)*.25

  |> lps($,100+15k*ad(.001,.5,8,trig),.8)

) |> out($)`,
  'map': '',
  'tanh': '\ntanh(sine(ntof(30))*5) |> out($)',
  'drums': '\ndrums() |> out($)',
  'euclid': '\ntri([60,63,65,69][t]|>ntof($))*ad(trig:euclid(5,8)) |> out($)',
  't': '\n[60,63,65][t] |> ntof($) |> saw($)*ad(trig:every(1/8)) |> out($)',
  'atan': '\natan(sine(ntof(30))) |> out($)',
  'supersaw': '\nsupersaw([50,57,60,62][t*2]|>ntof($))*lfosqr(1/16) |> out($)',
  'ap':
    'phaser=(in,stages=10)->{\n  a = lfosine(.5)\n\n  y = in\n  for (i in 0 .. stages-1) {\n    y = ap(y,99+999*a)\n  }\n\n  y + in\n}\n\nsaw(299)*.4 |> phaser($) |> out($)',
  'ch': '\nch() |> out($)',
  'fract': '\nfract(sine(ntof(12))*180) |> dc($) |> out($)',
  'swing': '\n[60,63,64,65][swing(t*2,.7)] |> ntof($)/2 |> saw($) |> out($)',
  'gauss': '\ngauss() |> out($)',
  'lp1': '\nwhite() |> lp1($,100+10k*lfosine(1)) |> out($)',
  'label': 'a',
  'log': '\nlog(abs(sine(ntof(30)))+.01) |> dc($) |> out($)',
  'print': '\nprint(42)',
  'smoothstep': '\nntof(30) |> smoothstep(sqr($),saw($),lfosine(1)) |> dc($) |> out($)',
  'fdn':
    '\ndrums(342) |> out($)\n\nsynth=x->(sqr(x)+ramp(x/1.502)+pink()*.8)/6  |> lps($,100+5000*ad(e:9,trig:every(1/16)),.7)*.4\n\nsynth([60,0,63,61][t] |> hold($) |> ntof($)/2)*ad(trig:every(1/8)) \n\n\n|> $+fdn($,room:.68) |> out($)',
  'pingpong': '\nntof(30) |> pingpong(sine($),-.1,.1) |> out($)',
  'cube': '\ncube(sine(ntof(30))) |> out($)',
  'isaudio': '\nisaudio(sine(1)) |> print($)\n\nisaudio(1) |> print($)',
  'lfosqr': '\npink()*lfosqr(1/4) |> out($)',
  'peaks': '\nwhite() |> peaks($,100+10k*lfosine(1),.5) |> out($)',
  'sin': '\nsin(phasor(ntof(50))*3.14*2) |> out($)',
  'sign': '\nsign(sine(ntof(30))) |> out($)',
  'phasor': '\npink()*phasor(2) |> out($)',
  'oh': '\noh() |> out($)',
  'dtof': '\n;[dtof(1),dtof(3),dtof(5)][t]*o2 |> saw($) |> out($)',
  'cos': '\ncos(sine(ntof(30))) |> dc($) |> out($)',
  'oversample': '\noversample(8,() -> pwm(ntof(51),lfosine(8))) |> out($)',
  'abs': '\nabs(sine(ntof(30))) |> out($)',
  'delay':
    '\ndrums(362) |> out($)\n\nsaw([56,56,59,55][t] |> ntof($))*ad(trig:every(1/5))*.16\n\n|> lp($,100+5434*ad(e:8,trig:every(1/5))) \n\n|> delay($,1/8,.7) |> out($)',
  'mtof': 'a',
  'sqr': '\nsqr(ntof(31)) |> out($)',
  'ls': '\nwhite() |> ls($,100+10k*lfosine(1),1,-30) |> out($)',
  'sam': `
sampler(sam('hello world'),trig:every(1)) |> out($)`,
  'espeak': `
sampler(espeak('hello world'),trig:every(1)) |> out($)`,
  'bongo': `trig=(euclid(3,8,0,1/2)+euclid(3,4,4,1))**.3

poly(4,trig,trig->(#scale*[o2,o3,o4].random(trig)).markov(trig),bongo) |> atan($*2) |> out($)`,
}
